import ProxyBase from '../../../../../../core/proxies/ProxyBase'

export class TopPlayersProxy extends ProxyBase {
  getTopPlayersTable(params) {
    return this.get('TopPlayers', params)
  }
  downloadTopPlayers(params) {
    return this.post('TopPlayers/Export', params, {}, 'download')
  }
  getTopYear(params) {
    return this.get('TopYear', params)
  }
}

export default new TopPlayersProxy('IndustryOverview/')
